import React, { useCallback, useContext, useEffect, useRef } from "react";
//import { useBlocker } from "react-router-dom";

export const OnBeforeUnloadContext = React.createContext();

const useOnBeforeUnload = ({ message }) => {
  const ref = (Math.random() + 1).toString(36).substring(7);
  const context = useContext(OnBeforeUnloadContext);
  const lock = useCallback(() => {
    context.current[ref] = message;
  }, []);
  const unlock = useCallback(() => {
    let new_context = new Object();
    for (let key of Object.keys(context.current)) {
      if (key != ref) new_context[key] = context.current[ref];
    }
    context.current = new_context;
  }, []);
  return { lock, unlock };
};

const getWindow = () => typeof window !== "undefined" && window;

const getHistory = () => getWindow()?.history?.state;

const OnBeforeUnloadProvider = ({ children }) => {
  const locks = useRef(new Object());
  const lastHistory = useRef(getHistory());

  const onBeforeUnload = (event) => {
    if (Object.keys(locks.current).length > 0) event.returnValue = "locked";
  };

  const onRouteChangeStart = (url) => {
    if (Object.keys(locks.current).length > 0) {
      revertTheChangeRouterJustMade();
      throw "Abort route change. Fake error, please ignore it.";
    }
  };

  const revertTheChangeRouterJustMade = useCallback(() => {
    const state = lastHistory.current;
    if (state !== null && history.state !== null) {
      //Will work on Back button not on next button
      history.go(1);
    }
  }, []);

  useEffect(() => {
    const storeLastHistoryState = () => {
      lastHistory.current = getHistory();
    };
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);

  //let blocker = useBlocker(
  //  ({ currentLocation, nextLocation }) => {
  //    return (Object.keys(locks.current).length > 0) &&
  //      currentLocation.pathname !== nextLocation.pathname;
  //  }
  //);

  return (
    <OnBeforeUnloadContext.Provider value={locks}>
      {false && blocker.state === "blocked" ? (
        <div>
          <p>Are you sure you want to leave?</p>
          <button onClick={() => blocker.proceed()}>Proceed</button>
          <button onClick={() => blocker.reset()}>Cancel</button>
        </div>
      ) : null}
      {children}
    </OnBeforeUnloadContext.Provider>
  );
};

export { OnBeforeUnloadProvider, useOnBeforeUnload };
